var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vxe-grid',{ref:"tableRef",attrs:{"columns":_vm.tableColumn,"data":_vm.rdsList,"loading":_vm.loading,"max-height":"300"},on:{"radio-change":_vm.handleRdsChange},scopedSlots:_vm._u([{key:"empty",fn:function(){return [_c('page-list-empty',{attrs:{"loading":_vm.loading}})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }